import { render, staticRenderFns } from "./paymentDetailAtachementsFile.vue?vue&type=template&id=2bf5e535&scoped=true"
import script from "./paymentDetailAtachementsFile.vue?vue&type=script&lang=js"
export * from "./paymentDetailAtachementsFile.vue?vue&type=script&lang=js"
import style0 from "./paymentDetailAtachementsFile.vue?vue&type=style&index=0&id=2bf5e535&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf5e535",
  null
  
)

export default component.exports